import { usePage } from '@inertiajs/react'

export interface AdminUser {
  userId?: number
  name?: string
  email?: string
}

export interface AdminPageProps {
  registrationEnabled?: boolean
  auth?: {
    user: AdminUser | null
  }
}

export function useAdminPageProps() {
  return usePage().props as AdminPageProps
}

export function useAdminAuth() {
  const props = useAdminPageProps()
  return props.auth ?? { user: null }
}
